import styled from "@emotion/styled";
import PrimaryButton from "shared/components/PrimaryButton";
import {
  COLOR_GREY_2,
  COLOR_GREY_5,
  COLOR_GREY_8,
  COLOR_GREY_11,
} from "shared/theme/colors";

export const StyledButton = styled(PrimaryButton)`
  &.MuiButton-root {
    font-size: 1rem;
    font-weight: 700;

    &.contained,
    &.outlined {
      border-radius: 0.5rem;
    }
  }
`;

export const StyledPrimaryButton = styled(StyledButton)`
  &.MuiButton-root {
    &.Mui-disabled {
      background-color: ${COLOR_GREY_5};
      color: ${COLOR_GREY_8};
    }
  }
`;

export const StyledSecondaryButton = styled(StyledButton)`
  &.MuiButton-root {
    color: ${COLOR_GREY_11};

    &.Mui-disabled {
      color: ${COLOR_GREY_8};
      background-color: ${COLOR_GREY_2};
    }
  }
`;
